var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3418 9.98779H64.2997C65.8156 9.98779 67.2694 10.59 68.3413 11.6619C69.4132 12.7338 70.0154 14.1876 70.0154 15.7035V26.6614",
    stroke: "#999999",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6638 70.0127H15.7059C14.19 70.0127 12.7362 69.4105 11.6643 68.3386C10.5924 67.2667 9.99023 65.8129 9.99023 64.297V53.3391",
    stroke: "#999999",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3244 42.0179L72.482 60.0688C73.6452 62.1326 73.6263 64.6586 72.4323 66.7047C71.2384 68.7509 69.0486 70.0102 66.6795 70.0129H46.3544C43.9846 70.0129 41.7927 68.7557 40.5965 66.7099C39.4004 64.6641 39.3796 62.1373 40.542 60.0721L50.6996 42.0179C51.881 39.9184 54.1028 38.6191 56.512 38.6191C58.9211 38.6191 61.143 39.9184 62.3244 42.0179Z",
    stroke: "#999999",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5131 54.7398V48.6206",
    stroke: "#999999",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5097 61.4928C56.4296 61.4928 56.3527 61.5249 56.2963 61.5819C56.2399 61.6389 56.2087 61.7161 56.2096 61.7963C56.2096 61.9193 56.2839 62.0302 56.3977 62.0769C56.5115 62.1237 56.6423 62.0971 56.7288 62.0097C56.8154 61.9222 56.8405 61.7911 56.7925 61.6778C56.7444 61.5645 56.6328 61.4915 56.5097 61.4928",
    stroke: "#999999",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.846 9.98779H13.3387C11.7907 9.98691 10.3058 10.6015 9.21121 11.6961C8.1166 12.7907 7.50205 14.2755 7.50293 15.8236V27.4951C7.50205 29.0431 8.1166 30.528 9.21121 31.6226C10.3058 32.7172 11.7907 33.3317 13.3387 33.3308H30.846C32.394 33.3317 33.8789 32.7172 34.9735 31.6226C36.0681 30.528 36.6826 29.0431 36.6818 27.4951V15.8236C36.6826 14.2755 36.0681 12.7907 34.9735 11.6961C33.8789 10.6015 32.394 9.98691 30.846 9.98779Z",
    stroke: "#999999",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6817 18.7408H7.50293",
    stroke: "#999999",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardAlert);
export default __webpack_public_path__ + "static/media/creditCardAlert.3a8a5be162ed0a22227182f2675bb86b.svg";
export { ForwardRef as ReactComponent };